import React, { memo } from 'react';
import { Position } from 'reactflow';
import { Tooltip } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import EnhancedHandle from './EnhancedHandle';

const TriggerNode = ({ data, isConnectable, selected }) => {
    // Determine trigger type and description
    const getTriggerTypeInfo = () => {
        const type = data.triggerType || data.config?.type;

        switch (type) {
            case 'manualTrigger':
                return {
                    label: 'Manual Trigger',
                    description: 'Workflow started manually'
                };
            case 'callEvaluation':
                return {
                    label: 'New Call Evaluation',
                    description: 'Triggered by completed call evaluation'
                };
            default:
                return {
                    label: 'Trigger',
                    description: 'Workflow starting point'
                };
        }
    };

    const triggerInfo = getTriggerTypeInfo();

    // Show execution count badge if available (for monitoring view)
    const ExecutionCountBadge = () => {
        if (data.executionCount === undefined) return null;

        return (
            <div style={{
                position: 'absolute',
                top: -8,
                right: -8,
                background: '#1890ff',
                color: 'white',
                borderRadius: '50%',
                width: 22,
                height: 22,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 'bold',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                zIndex: 10
            }}>
                {data.executionCount}
            </div>
        );
    };

    return (
        <Tooltip title={triggerInfo.description}>
            <div
                style={{
                    width: 220,
                    position: 'relative',
                    borderRadius: '20px 20px 8px 8px',
                    background: selected ? '#fff7e6' : 'white',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: selected ? '#faad14' : '#d9d9d9',
                    overflow: 'hidden',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                    fontFamily: 'Arial, sans-serif'
                }}
            >
                <ExecutionCountBadge />

                {/* Header */}
                <div style={{
                    background: '#faad14',
                    color: 'white',
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: '1px solid #d9d9d9'
                }}>
                    <ThunderboltOutlined style={{ fontSize: 16, marginRight: 8 }} />
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {data.label || 'Trigger'}
                    </div>
                </div>

                {/* Content */}
                <div style={{ padding: '12px 16px' }}>
                    <div style={{ fontSize: '13px' }}>
                        {triggerInfo.label}
                    </div>
                </div>

                {/* Output handle - using enhanced handle */}
                <EnhancedHandle
                    type="source"
                    position={Position.Bottom}
                    id="a"
                    style={{
                        bottom: -6
                    }}
                    color="#faad14"
                    isConnectable={isConnectable}
                />
            </div>
        </Tooltip>
    );
};

export default memo(TriggerNode);
